type BeforeInstallPromptChoiceResult = {
    outcome: 'accepted' | 'dismissed';
    platform: string;
};

interface BeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: Promise<BeforeInstallPromptChoiceResult>;
    prompt(): Promise<void>;
}

type ExpiringStorageValue<T> = {
    value: T;
    expiry: number;
};

export function register() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/service-worker.js')
                .then((_registration) => {
                    // console.log('Service Worker registered:', registration);
                })
                .catch((_error) => {
                    // console.error('Error registering Service Worker:', error);
                });
        });
    }
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister();
            })
            .catch((_error) => {
                // console.error('Error unregistering Service Worker:', error);
            });
    }
}



function getWithExpiry<T>(key: string): T | null {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr) as ExpiringStorageValue<T>
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}

// checks if the localStorage item has been set
function getVisited() {
    return getWithExpiry('pwa-install-prompt-dam-admin-restaurant')
    // return localStorage.getItem('install-prompt');
}


let installPromptEvent: BeforeInstallPromptEvent | null = null;

function installPWA() {
    if (installPromptEvent) {
        installPromptEvent.prompt();

        installPromptEvent.userChoice
            .then((choiceResult) => {
                if(choiceResult.outcome === 'accepted') {
                    const pwaInstallPromptBtn = document.querySelector<HTMLElement>(".pwa-install-prompt-btn");
                    // pwaInstallPromptBtn?.style.display = '';
                    pwaInstallPromptBtn?.classList.remove("show-btn");
                    pwaInstallPromptBtn?.classList.add("d-none");
                }

                installPromptEvent = null;
            })
    }
}

window.addEventListener("beforeinstallprompt", (event) => {
    const beforeInstallPromptEvent = event as BeforeInstallPromptEvent;
    beforeInstallPromptEvent.preventDefault();

    setTimeout(() => {
        // install button fast preview (only for login page)
        const pwaInstallPromptBtn = document.querySelector<HTMLElement>(".pwa-install-prompt-btn");
        if (!getVisited()) {
            if (pwaInstallPromptBtn) {
                pwaInstallPromptBtn?.classList.remove("d-none");
            }
        }
    }, 100);
    
    setTimeout(() => {
        const pwaInstallPromptBtn = document.querySelector<HTMLElement>(".pwa-install-prompt-btn");

        // if no localStorage is set, first time visitor
        if (!getVisited()) {
            if (pwaInstallPromptBtn) {
                pwaInstallPromptBtn.style.display = '';
                pwaInstallPromptBtn?.classList.remove("d-none");
                setTimeout(() => {
                    pwaInstallPromptBtn?.classList.add("show-btn");
                    pwaInstallPromptBtn?.classList.add("show-text");
                }, 50);
            }
        }
        else {
            // customPromptElement.style.display = '';
        }

        installPromptEvent = beforeInstallPromptEvent;

        pwaInstallPromptBtn?.addEventListener("click", (event) => {
            event.preventDefault();
            installPWA();
        });
    }, 2000);
});

window.addEventListener('load', () => {
    // // Because the 'LayoutAndHeader' component is loaded as a child of 'AuthenticationHandler', the PWA install button is not loaded immediately after the window is loaded. So the following content wont works!
    // const pwaInstallPromptBtn = document.querySelector(".pwa-install-prompt-btn");
    // pwaInstallPromptBtn?.addEventListener("click", (e) => {
    //     e.preventDefault();
    //     installPWA();
    // });
});
